<script setup>
// Lupa da lista de conversas (pedido do Ivan, 02/09/2026): busca por palavra
// dentro das MENSAGENS, como o WhatsApp Web. O ChatList é quem consulta a API;
// aqui só a caixa de texto.
import { ref, watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
  minLength: { type: Number, default: 3 },
});
const emit = defineEmits(['update:modelValue', 'close']);
const { t } = useI18n();

const inputRef = ref(null);
const local = ref(props.modelValue);
watch(
  () => props.modelValue,
  v => {
    if (v !== local.value) local.value = v;
  }
);
watch(local, v => emit('update:modelValue', v));

const clear = () => {
  local.value = '';
  inputRef.value?.focus();
};
const close = () => {
  local.value = '';
  emit('close');
};
const onKeydown = e => {
  if (e.key === 'Escape') close();
};

onMounted(() => inputRef.value?.focus());
</script>

<template>
  <div
    class="flex items-center gap-2 px-3 py-2 border-b border-n-weak bg-n-solid-2"
  >
    <span
      class="flex-shrink-0 size-4 text-n-slate-10"
      :class="isLoading ? 'i-lucide-loader-2 animate-spin' : 'i-lucide-search'"
    />
    <input
      ref="inputRef"
      v-model="local"
      type="text"
      class="flex-1 h-6 text-sm bg-transparent border-0 text-n-slate-12 placeholder:text-n-slate-10 focus:outline-none"
      :placeholder="t('CHAT_LIST.MESSAGE_SEARCH.PLACEHOLDER')"
      :aria-label="t('CHAT_LIST.MESSAGE_SEARCH.PLACEHOLDER')"
      @keydown="onKeydown"
    />
    <span
      v-if="local.length > 0 && local.trim().length < minLength"
      class="text-xs text-n-slate-10 whitespace-nowrap"
    >
      {{ t('CHAT_LIST.MESSAGE_SEARCH.MIN_HINT', { count: minLength }) }}
    </span>
    <button
      v-if="local.length"
      type="button"
      class="p-0.5 rounded hover:bg-n-alpha-2"
      :aria-label="t('CHAT_LIST.MESSAGE_SEARCH.CLEAR')"
      @click="clear"
    >
      <span class="i-lucide-eraser size-4 text-n-slate-11" />
    </button>
    <button
      type="button"
      class="p-0.5 rounded hover:bg-n-alpha-2"
      :aria-label="t('CHAT_LIST.MESSAGE_SEARCH.CLOSE')"
      @click="close"
    >
      <span class="i-lucide-x size-4 text-n-slate-11" />
    </button>
  </div>
</template>
